import Workflow from '~/client/src/shared/models/Workflow'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'
import PermitBallInCourtStore from '~/client/src/shared/stores/ui/PermitBallInCourt.store'

export default function isUserBicForCurrentStep(
  userId: string,
  permit: Workflow,
  workflowTypesStore: WorkflowTypesStore | undefined,
  permitBicStore: PermitBallInCourtStore | undefined,
): boolean {
  if (!permitBicStore) return false
  const permitType = workflowTypesStore?.getPermitTypeById(permit.typeId)
  if (!permitType) return false
  const stepRuleIds = permitType.getStepRuleIds(permit.currentWorkflowStepId)
  return permitBicStore.isUserAllowedByBicRules(
    userId,
    permit,
    stepRuleIds,
    permitType.getStepCompletionMode(permit.currentWorkflowStepId),
  )
}
